import { apiClient } from './client';

/**
 * Cf wiki §24.12 + P10 — endpoint generique de consommation d'item.
 *   POST /api/v1/ItemUse/{itemId}
 *
 * Dispatcher cote serveur par Item.Kind :
 *   - Document     -> +1 niveau a la recherche cible
 *   - Cle          -> renvoie le targetCode (a relayer par le caller)
 *   - Scientifique -> placeholder (mission espionnage future)
 *   - Artifact / Relic / ComponentPart -> KIND_NOT_USABLE
 */

const BASE = '/api/v1/ItemUse';

export interface UseItemPDTO {
  playerUniverseId: number;
  /** Optionnel : utilise pour les Cle quand l'item n'a pas son
   * propre TargetCode (fallback rare V1). */
  contextCode?: string;
}

export interface ItemUseResult {
  itemId: number;
  kind: string;
  remainingQuantity: number;
  effect: string;     // "research_unlocked" | "research_leveled" | "key_consumed" | ...
  message: string;
  payload: unknown;   // forme varie par effect
}

export async function useItem(itemId: number, body: UseItemPDTO): Promise<ItemUseResult> {
  const { data } = await apiClient.post<ItemUseResult>(`${BASE}/${itemId}`, body);
  return data;
}
